module.exports = __webpack_public_path__ + "static/media/mockup.1f56c8b3.webp";